import { WORKSPACE_ROLES_LABELS } from "@common/constants";
import { UserAvatar } from "@components/avatar/UserAvatar";
import { AvatarTooltip } from "@components/avatar/AvatarTooltip";
import { FC } from "react";
import { UserWorkspaceRole } from "@common/userWorkspaceRoles";

interface TeamMemberIconProps {
    name: string;
    role?: UserWorkspaceRole;
    email: string | null;
    avatar: string | null;
    iconColor: string;
}

/** A team member's avatar with their name and role in a tooltip. */
export const TeamMemberIcon: FC<TeamMemberIconProps> = ({
    name,
    role,
    email,
    iconColor,
    avatar,
}) => (
    <AvatarTooltip
        title={name}
        content={role === undefined ? undefined : WORKSPACE_ROLES_LABELS[role]}
    >
        <UserAvatar user={{ email, name, iconColor, avatar }} />
    </AvatarTooltip>
);
